// Language maps hold plain strings; values go in `{name}` placeholders.
export const fillPlaceholders = (template, values) => template.replace(/\{(\w+)\}/g, (placeholder, name) => name in values ? `${values[name]}` : placeholder);
//# sourceMappingURL=placeholders.js.map